import axios, { Method } from "axios";
import { ApiBrokerResponseStructure } from "../../interfaces/DataDefaultStructureResponse";
import { fetchAuthSession } from "aws-amplify/auth";
import { getRawToken } from "../../utils/tokenFunctions";

interface FetchDataParams<T = any> {
  method: Method;
  url: string;
  data?: any;
  params?: Record<string, any>;
  headers?: Record<string, string>;
  useAuth?: boolean;
}

export async function fetchData<T>({
  method,
  url,
  data,
  params,
  headers = {},
  useAuth = true,
}: FetchDataParams): Promise<ApiBrokerResponseStructure<T>> {
  try {
    let authHeader: Record<string, string> = {};

    if (useAuth) {
      // Primero intentamos obtener token raw de localStorage (LTI mode)
      let token = getRawToken();
      
      // Si no hay token en localStorage, intentamos fetchAuthSession (COGNITO mode)
      if (!token) {
        try {
          const session = await fetchAuthSession();
          token = session.tokens?.accessToken?.toString() || null;
        } catch (error) {
          console.log("No se pudo obtener sesión de Cognito, usando token de localStorage si existe");
        }
      }

      if (token) {
        authHeader = { Authorization: `Bearer ${token}` };
      }
    }

    // Combinamos headers por defecto con Authorization si hay token
    const finalHeaders: Record<string, string> = {
      "Content-Type": "application/json",
      ...headers,
      ...authHeader,
    };

    const response = await axios({
      url,
      method,
      data,
      params,
      headers: finalHeaders,
    });

    const { data: responseData, status } = response;
    return Object.assign({ data: responseData, status });
  } catch (error: any) {
    console.error("API Error:", error);
    throw new Error(
      error?.response?.data?.message || error.message || "Error de API"
    );
  }
}
